import { render, staticRenderFns } from "./CompraFrancisco.vue?vue&type=template&id=dee3215a&"
import script from "./CompraFrancisco.vue?vue&type=script&lang=js&"
export * from "./CompraFrancisco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports